/**
 * A link to a certain page, an anchor tag
 */

import styled from 'styled-components';

const ModalContent = styled.div`
  background-color: white;
  height: calc(100% - 140px);
  color: black;
  font-size: 1rem;
  overflow: auto;
  width: 100%;
  margin: 0 auto;
  flex-grow: 1;

  &.small {
    width: 45%;
    margin: 2% auto;
  }

  &.large-padding {
    padding: 25px;
  }

  &.noheader {
    height: calc(100% - 12px);
  }

  flex-grow: 1;

  .MuiTab-root {
    // min-height: 56px;
    min-width: 160px;
    padding: 12px 24px;
    gap: 0.75rem;
  }

  .validationError {
    color: red;
    border-bottom: 2px red solid !important;
    font-size: 1rem;
    position: relative;
    padding-right: 28px;
  }

  .validationError::after {
    content: '❌';
    font-size: 1.2rem;
    position: absolute;
    right: 6px;
    top: 50%;
    width: 1.2rem;
    height: 1.2rem;
    display: grid;
    place-items: center;
    transform: translateY(-50%);
    color: #f14767;
    pointer-events: none;
  }
`;

export default ModalContent;
